import React from "react";

var FileEuroIcon = function FileEuroIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17 0v5h5zm-2 0H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7h-7zm-3 14a1 1 0 0 1 0 2h-1.808c.431 1.162 1.575 2 2.929 2H14a1 1 0 0 1 0 2h-.879c-2.473 0-4.542-1.721-5.018-4H7a1 1 0 0 1 0-2h1.104c.476-2.279 2.544-4 5.018-4H14a1 1 0 0 1 0 2h-.879c-1.354 0-2.499.838-2.929 2z"
  }));
};

FileEuroIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
FileEuroIcon.defaultProps.solid = true;
export default FileEuroIcon;